// Unit types listing events (analytics sheet → "Unit Types Listing Page"),
// plus the unit-only floor-plan tracker. The rest of the unit-type *details*
// events now come from the shared `detailAnalytics` factory.
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';
import {listingAnalytics} from './listing-page.analytics';
import type {TrackedItem} from './shared';

const DETAILS = AnalyticsEntryPoint.UnitTypeDetailsPage;

// The unit-types listing card fires `item_card_click` (not `card_click`) per the
// analytics sheet — a load-bearing deviation carried by the factory option.
const unitTypes = listingAnalytics(AnalyticsEntryPoint.UnitTypesListingPage, {cardEvent: 'item_card_click'});

export const trackUnitTypesListingCardClick = unitTypes.cardClick;
export const trackUnitTypesListingViewItemClick = unitTypes.viewItemClick;
export const trackUnitTypesListingRegisterInterestClick = unitTypes.registerInterestClick;

export function trackUnitTypeFloorPlanClick(item: TrackedItem) {
  logAnalyticsEvent('floor_plan_click', {
    entry_point: DETAILS,
    item_id: item.id,
    item_name: item.name,
  });
}
